var map = {
	"./de": 838,
	"./de.js": 838,
	"./en": 839,
	"./en-ca": 840,
	"./en-ca.js": 840,
	"./en-gb": 841,
	"./en-gb.js": 841,
	"./en.js": 839,
	"./es": 842,
	"./es.js": 842,
	"./fr": 843,
	"./fr.js": 843,
	"./it": 844,
	"./it.js": 844,
	"./ja": 845,
	"./ja.js": 845,
	"./nl": 846,
	"./nl.js": 846,
	"./pt": 847,
	"./pt.js": 847
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1352;


//////////////////
// WEBPACK FOOTER
// ./src/web/js/app/lib/moment/lang ^\.\/.*$
// module id = 1352
// module chunks = 80